import IconClose from "@mui/icons-material/Close";
import {
  Button,
  DialogActions,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import BazarButton from "components/BazarButton";
import BazarIconButton from "components/BazarIconButton";
import { FlexBox } from "components/flex-box";
import LazyImage from "components/LazyImage";
import { H2, Span, Tiny } from "components/Typography";
import { FC } from "react";

type Props = {
  toggleOpen: boolean;
  dialogueTitle: string;
  dialogueContent: string;
  buttonTitle: string;
  toggleOpenClose: () => void;
  setFunction: () => void;
};

export const DialugoeDecision: FC<Props> = ({
  toggleOpen,
  dialogueTitle,
  dialogueContent,
  buttonTitle,
  toggleOpenClose,
  setFunction,
}) => {
  return (
    <div>
      <Dialog
        open={toggleOpen}
        onClose={toggleOpenClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ zIndex: 15002 }}
      >
        <DialogTitle id="alert-dialog-title">{dialogueTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {dialogueContent}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={setFunction} color="primary">
            {buttonTitle}
          </Button>
          <Button onClick={toggleOpenClose} color="info" autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
